import React from 'react';
import { StyleSheet, View , FlatList,ActivityIndicator} from 'react-native';
import { Avatar, Appbar,Text,Snackbar } from 'react-native-paper';
import { Rating } from 'react-native-ratings';


const sportIcons = { 
  
  "اسپینینگ":
  require("../assets/sportsicons/spin.png"),

  "ایروبیک":
  require("../assets/sportsicons/rhytm.png"),

  "بدنسازی":
  require("../assets/sportsicons/gym.png"),

  "تمرینات فانکشنال / کراسفیت":
  require("../assets/sportsicons/cf.png"),

  "تمرینات لس میلز":
  require("../assets/sportsicons/bp.png"),

  "تمرینات معلق":
  require("../assets/sportsicons/trx.png"),

  "جامپینگ فیتنس":
  require("../assets/sportsicons/jump.png"),

  "فیتنس":
  require("../assets/sportsicons/fit.png"),

  "دوچرخه سواری":
  require("../assets/sportsicons/bike.png"),

  "ورزش های آبی":
  require("../assets/sportsicons/swim.png"),

  "ورزش های آزاد":
  require("../assets/sportsicons/free.png"),

  "ورزش کودکان":
  require("../assets/sportsicons/kids.png"),

  "کیک بوکس / رزمی":
  require("../assets/sportsicons/kb.png"),

  "یوگا / پیلاتس":
  require("../assets/sportsicons/yoga.png"),

  "متفرقه":
  require("../assets/sportsicons/other.png"),

} ;

export default class CommentScreen extends React.Component {

  state = {
    loading : false,
    Comments : null,
    page :1,
    loadingMore: true,
    refreshing: false,
    connectionToast:false
  
 };

 _handleLoadMore = () => {
  this.setState(
    (prevState, nextProps) => ({
      page: prevState.page + 1,
      loadingMore: true
    }),
    () => {
      this._fetchComments();
    }
  );
};

_handleRefresh = () => {
  this.setState(
    {
      page: 1,
      refreshing: true
    },
    () => {
      this._fetchComments();
    }
  );
};

_renderFooter = () => {
  if (!this.state.loadingMore){
    if(!(this.state.comments.length > 0)){
      return (
        <View
        style={{
          position: 'relative',
          width: '100%',
          paddingVertical: 10
        }}
      >
        <Text style={{fontFamily:'iransans', color:'#2ebbc4', marginLeft:'auto', marginRight:'auto', textAlign: alignR}}>نتیجه ای پیدا نشد</Text>
      </View>
      );
    } else {
      return null;
    }
  }

  return (
    <View
      style={{
        position: 'relative',
        width: '100%',
        paddingVertical: 10
      }}
    >
      <ActivityIndicator animating size="large" />
    </View>
  );
};

_fetchComments = () => {
  const { page } = this.state;
  let request = {};
  request.offset=(page - 1 )*10;
  request.limit=10;
  fetch('https://fitwayz.ir/api/classes/'+global.activeClassInfo.id+'/comments',
  {
    method:'POST',
    withCredentials: true,
     
    headers:{
      Accept: 'application/json',
      Authorization: 'Bearer ' + global.token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request)
  })
  .then(response => response.json()).then(responseJson => {
    this.setState((prevState, nextProps) => ({
      comments:
        page === 1
          ? Array.from(responseJson.data)
          : [...this.state.comments, ...responseJson.data],

      loadingMore:
      responseJson.data.length < 10
          ? false : true,

      refreshing: false
    }));
  })
  .catch(error => {
    this.setState({connectionToast:true})
  });
}

componentDidMount(){
  this._fetchComments();
}


render(){

  return (

<View style={{height:'100%', backgroundColor:'white'}}>

  <Appbar.Header style={{height:50,backgroundColor:'white'}} >
    <Appbar.Action icon="menu" color='#3a3635' onPress={() => this.props.navigation.openDrawer()} />
    <Appbar.Content title='دیدگاه کاربران'/>
    <Appbar.Action style={{marginLeft:'auto'}} icon="arrow-left" color='#3a3635' onPress={() => {this.props.navigation.goBack()}} />
  </Appbar.Header>
  
  <View style={{backgroundColor:'white',zIndex:100,paddingHorizontal:20,paddingBottom:2,paddingTop:8 }}>
    <Text style={{fontSize:18}}>کلاس</Text>
  </View>

  <View style={styles.container}>
     <Avatar.Icon color='#21706c' style={{backgroundColor:'white',margin:-18,marginLeft:-6,marginRight:-10}} size={85} icon={sportIcons[global.activeClassInfo.sport]} />
     <View>
     <Text style={{ color:'#3a3635',fontSize:16}}>{global.activeClassInfo.classname}</Text>
     <Text style={{ color:'#3a3635',fontSize:14}}>باشگاه {global.activeClassInfo.gymname}</Text>
     </View>
  </View>

  <View style={{backgroundColor:'white'}}>
  <View style={{marginHorizontal:20,paddingBottom:5 ,  borderColor:'grey',borderTopWidth:0.3}}>
    <Text style={{fontSize:18}}>مربی</Text>
  </View>
  </View>


  <View style={{backgroundColor:'white',flexDirection:'row',paddingHorizontal:16,alignItems:'center',paddingBottom:7}}>
  <Avatar.Image size={40} source={{uri : this.props.route.params.uri}}  />
  <Text style={{ color:'#3a3635',marginHorizontal:10}}>{global.activeClassInfo.trainer}</Text>

  </View>

  <View style={{backgroundColor:'white', marginTop :5}}>
  <View style={{marginHorizontal:20,paddingBottom:5 ,  borderColor:'grey',borderTopWidth:0.3,}}>
    <Text style={{fontSize:18, marginTop :5}}>دیدگاه ها</Text>
  </View>
  </View>


  <FlatList 
          style={{flex:1,marginHorizontal:20,marginBottom:10,borderColor:'grey',borderWidth:0.3,borderRadius:10}}
          contentContainerStyle={{paddingHorizontal:20,paddingVertical:5}}
          data={this.state.comments}
          keyExtractor={item => item.id.toString()}
          renderItem={({ item }) => (

            <View style={{paddingVertical:10,borderColor:'grey',borderBottomWidth:0.3,flexDirection:'row'}}>
            <Avatar.Icon color='#3a3635' style={{marginLeft:-10,marginRight:5}} size={30} icon='comment-outline' />
              <View>
              <View style={{flexDirection:'row'}}>
                <Text style={{fontSize:10,color:'#3a3635'}}>{item.date}</Text>
                <Text style={{fontSize:10,color:'#3a3635'}}>  -  </Text>
                <Text style={{fontSize:10,color:'#3a3635'}}>امتیاز :</Text>
                <Rating
                  type='star'
                  readonly={true}
                  ratingColor="#3a3635"
                  imageSize={8}
                  style={{marginTop:4,marginHorizontal:5}}
                  startingValue={item.rate}
                />
              </View>
              <Text style={{fontSize:12,color:'#3a3635',}}>{item.text}</Text>
              </View>
            </View>

          )}

          onEndReached={this._handleLoadMore}
          onEndReachedThreshold={0.5}
          initialNumToRender={10}
          ListFooterComponent={this._renderFooter}
          onRefresh={this._handleRefresh}
          refreshing={this.state.refreshing}
          />  

<Snackbar
          style={{zIndex:200}}
          visible={this.state.connectionToast}
          onDismiss={() => this.setState({connectionToast:false})}>
         ارتباط اینترنت با مشکل مواجه است
        </Snackbar>



</View>


    );
  }

}

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    flexDirection:'row',
    paddingBottom:10,
  },


});
  